import React from 'react';
import DeliveryManagementDashboard from '../../components/DeliveryManagementDashboard';

const DeliveryManagement = () => {
  // Role checking is handled by RequireRole wrapper in App.jsx
  // and by DeliveryManagementDashboard component
  return <DeliveryManagementDashboard />;
};

export default DeliveryManagement;
